import type { CreateSurveyInput } from '@lms/shared'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'

export function useTrainingSurvey(trainingId: string) {
  return useQuery({
    queryKey: ['training-surveys', trainingId],
    queryFn: () => api.get(`/api/training-surveys/training/${trainingId}`),
    enabled: !!trainingId,
  })
}

export function useCreateSurvey() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateSurveyInput) => api.post('/api/training-surveys', data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['training-surveys'] }),
  })
}

export function useSendSurveyReminder() {
  return useMutation({
    mutationFn: (surveyId: string) => api.post(`/api/training-surveys/${surveyId}/remind`),
  })
}
